// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { SettingItem } from './SettingItem';
/**
 * 设置分组 实体类
 * 设置分组，只有末级分组才能有设置项
 */
export class SettingGroup extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 采用有含义的编码，全局编码唯一 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 顺序号 : 顺序号，用于排序 */
  private _sequence: number;

  /** 设置：顺序号 */
  public get sequence() {
    return this._sequence;
  }

  /** 获取：顺序号 */
  public set sequence(value: number) {
    this._sequence = value;
  }

  /** 上级分组 的ID */
  private _parent_ID: string;

  /** 获取：上级分组 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：上级分组 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 上级分组  */
  private _parent: SettingGroup;

  /** 获取：上级分组  */
  public get parent() {
    return this._parent;
  }

  /** 设置：上级分组  */
  public set parent(value: SettingGroup) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 子分组 */
  private _children: Array<SettingGroup>;

  /** 获取：子分组 */
  public get children() {
    return this._children;
  }

  /** 设置：子分组 */
  public set children(value: Array<SettingGroup>) {
    this._children = value;
  }

  /** 设置分组 */
  private _settingItems: Array<SettingItem>;

  /** 获取：设置分组 */
  public get settingItems() {
    return this._settingItems;
  }

  /** 设置：设置分组 */
  public set settingItems(value: Array<SettingItem>) {
    this._settingItems = value;
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._description = '';
    this._sequence = 0;
    this._parent_ID = '';
    this._parent = null;
    this._children = new Array<SettingGroup>();
    this._settingItems = new Array<SettingItem>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: SettingGroup, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.description = element.description;
      this.sequence = element.sequence;
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.description = json.Description;
    this.sequence = json.Sequence;
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = SettingGroup.Create(json.Parent);
    // }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const settingGroup = SettingGroup.Create(element);
        // settingGroup.parent = this;
        this.children.push(settingGroup);
      });
    }
    if (json.SettingItems && json.SettingItems.length > 0) {
      json.SettingItems.forEach((element: any) => {
        const settingItem = SettingItem.Create(element);
        // settingItem.settingGroup = this;
        this.settingItems.push(settingItem);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Description = this.description;
    json.Sequence = this.sequence;
    json.Parent_ID = this.parent_ID;
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
    if (this.settingItems && this.settingItems.length > 0) {
      json.SettingItems = [];
      this.settingItems.forEach((element) => {
        json.SettingItems.push(element.toJson());
      });
    }
  }

  static Create(json: any): SettingGroup {
    const settingGroup = new SettingGroup();
    settingGroup.Deserialize(json);
    settingGroup.json = json;
    return settingGroup;
  }
}
